import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',

    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

//TODO replace with built-in confirm dialog
class SimpleModal extends React.Component {

  handleClick = char => {
    this.props.selectCharacter(char);
    this.props.handleModalClose();
  }

  render() {
    const { classes } = this.props;

    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.props.open}
        onClose={this.props.handleModalClose}
      >
        <div style={getModalStyle()} className={classes.paper}>
          <List component="nav">
            {this.props.characters.map(c=>{
              return (
                <ListItem button key={c.name} onClick={()=>this.handleClick(c.name)}>
                  <ListItemText primary={c.name} />
                </ListItem>
              )
            })}
          </List>
        </div>
      </Modal>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const SimpleModalWrapped = withStyles(styles)(SimpleModal);

export default SimpleModalWrapped;



// WEBPACK FOOTER //
// ./src/SimpleModalWrapper.js